import VehiclePlateIcon from '@/common/assets/icons/vehiclePlateIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const FreeZonePlateShow = ({
  plateData,
}: {
  plateData: {
    vehicle_plate_top?: number | string;
    vehicle_plate_bottom?: number | string;
  };
}) => {
  return (
    <Flex
      className={css({
        flexDirection: 'row-reverse',
        alignItems: 'center',
      })}
    >
      <Box
        className={css({
          bg: '#0042AD',
          borderLeftRadius: '4px',
          borderRight: 'none',
          width: '15px',
        })}
      >
        <VehiclePlateIcon
          className={css({
            height: '24px',
            position: 'relative',
            left: '10px',
          })}
        />
      </Box>
      <Box
        className={css({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          px: '4px',
          gap: '3px',
          border: '1px solid',
          height: '24px',
        })}
      >
        <Typography fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_bottom}
        </Typography>
      </Box>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          height: '24px',
          alignItems: 'center',
          position: 'relative',
          px: '3px',
          border: '1px solid',
          borderLeft: 'none',
          borderRightRadius: '4px',
        }}
      >
        <Typography top={'-20px'} fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_top}
        </Typography>
      </Box>
    </Flex>
  );
};

export default FreeZonePlateShow;
